var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEndFlowActivity = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 50,
    height: 50,
    rx: 25,
    fill: "#993232"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0126 25.9946H16.3563V28.4702H20.6474V30H14.4521V20.7578H20.6347V22.3003H16.3563V24.5029H20.0126V25.9946ZM29.1802 30H27.2759L23.5688 23.9189V30H21.6646V20.7578H23.5688L27.2822 26.8516V20.7578H29.1802V30ZM30.7433 30V20.7578H33.587C34.3995 20.7578 35.1253 20.9419 35.7643 21.3101C36.4075 21.674 36.909 22.1945 37.2687 22.8716C37.6284 23.5444 37.8082 24.3104 37.8082 25.1694V25.5947C37.8082 26.4538 37.6305 27.2176 37.275 27.8862C36.9238 28.5549 36.4265 29.0732 35.7833 29.4414C35.1401 29.8096 34.4143 29.9958 33.6061 30H30.7433ZM32.6476 22.3003V28.4702H33.568C34.3128 28.4702 34.8819 28.2269 35.2755 27.7402C35.669 27.2536 35.8701 26.5575 35.8785 25.6519V25.1631C35.8785 24.2236 35.6839 23.5127 35.2945 23.0303C34.9052 22.5436 34.336 22.3003 33.587 22.3003H32.6476Z",
    fill: "#F0F1F5"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEndFlowActivity);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/endFlowActivity.3581b1aa8062254842385a9662546a69.svg";